import styled from 'styled-components';

const shouldForwardProp = prop => !['$isActive'].includes(prop);

export const CardContainer = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${props => (props.$isActive ? '#BDB4FE' : '#DDDDDD')};
  background: ${props => (props.$isActive ? '#F4F3FF' : 'transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const CheckWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
